import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase/firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import "../styles/forms.css";

const WearerSignup = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dorm, setDorm] = useState("");
  const [roomNumber, setRoomNumber] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      await setDoc(doc(db, "users", userCredential.user.uid), {
        username,
        email,
        dorm,
        roomNumber,
        role: "wearer",
      });

      navigate("/");
    } catch (error) {
      console.error("Signup Error: ", error);
    }
  };

  return (
    <div className="siteWrapper">
      <div className="signup-container">
        <h2>Are you a wearer?</h2>
        <form onSubmit={handleSignup} className="signup-form">
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required placeholder="Enter username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required placeholder="Enter email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required placeholder="Enter password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="dorm">Dorm:</label>
            <input
              type="text"
              id="dorm"
              value={dorm}
              onChange={(e) => setDorm(e.target.value)}
              required placeholder="Enter dorm"
            />
          </div>
          <div className="form-group">
            <label htmlFor="roomNumber">Room Number:</label>
            <input
              type="text"
              id="roomNumber"
              value={roomNumber}
              onChange={(e) => setRoomNumber(e.target.value)}
              required placeholder="Enter room number"
            />
          </div>
          <button className="button" type="submit">Sign Up</button>
        </form>
      </div>
    </div>
  );
};

export default WearerSignup;
